import { css, styled } from '@slal/ui';
import { Input } from '@slal/ui/forms';
import { ErrorIcon } from '@slal/ui/icons';
import { TextField as SUITextField } from '@slal/ui/react-hook-form/fields';
import { P, Text } from '@slal/ui/typography';
import { FieldWrapperProps } from './types';

export const relatedFieldIndent = '44px';

export const StyledForm = styled.form`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledFieldSet = styled.fieldset`
    margin: 0 0 ${({ theme }) => theme.space[7]};
    padding: 0;
    border: 0;
`;

export const FieldWrapper = styled.div<FieldWrapperProps>`
    margin-top: ${({ theme }) => theme.space[6]};

    > label {
        margin-bottom: ${({ theme }) => theme.space[4]};
        font-family: ${({ theme }) => theme.fonts.headings.family};
        font-size: ${({ theme }) => theme.fontSizes[4]};
        font-weight: 500;
    }

    input {
        font-size: 16px;
    }

    input[type='checkbox'] {
        margin-right: ${({ theme }) => theme.space[4]};
    }

    input[type='radio'] {
        cursor: pointer;
    }

    ${({ theme, variant }) =>
        variant === 'related' &&
        css`
            margin-top: -${theme.space[7]};
            margin-left: ${relatedFieldIndent};
            > label {
                font-family: ${theme.fonts.sansSerif.family};
                font-weight: ${theme.fonts.sansSerif.fontWeights.regular};
                color: ${theme.colors.neutral__light__70};
            }
        `}
`;

export const ErrorWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.space[3]};
`;

export const FieldErrorMessage = styled(P)`
    margin-top: ${({ theme }) => theme.space[2]};
    color: ${({ theme }) => theme.colors.danger};
    font-size: ${({ theme }) => theme.fontSizes[3]};
`;

export const StyledErrorIcon = styled(ErrorIcon)`
    color: ${({ theme }) => theme.colors.danger};
    margin-right: ${({ theme }) => theme.space[3]};
`;

export const StyledFieldHelp = styled(Text)`
    display: block;
    margin-top: ${({ theme }) => theme.space[4]};
    font-size: ${({ theme }) => theme.fontSizes[3]};
    font-family: ${({ theme }) => theme.fonts.sansSerif.family};
    font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    color: ${({ theme }) => theme.colors.neutral__light__70}!important;
`;

StyledFieldHelp.defaultProps = {
    tag: 'span',
};

const getSize = (size?: number) => {
    if (!size) return '100%';
    switch (size) {
        case 4:
            return '84px';
        case 3:
            return '68px';
        case 2:
            return '62px';
        default:
            return '44px';
    }
};

export const StyledInput = styled(Input)`
    width: ${({ size }) => getSize(size)};
    margin-right: ${({ size, theme }) => (size ? theme.space[4] : '0')};
`;

export const StyledDateFieldSet = styled(StyledFieldSet)`
    padding-top: ${({ theme }) => theme.space[2]};
    margin: 0;
    label {
        margin-bottom: ${({ theme }) => theme.space[4]};
        font-size: inherit;
        font-weight: ${({ theme }) => theme.fonts.sansSerif.fontWeights.regular};
    }
`;

export const TextField = styled(SUITextField)`
    width: ${({ size }) => getSize(size)};
`;

export const CurrencyInput = styled(Input)`
    width: 150px;
`;

export const RadioFieldsContainer = styled.fieldset<{ stacked?: boolean }>`
    display: inline-flex;
    margin: 0;
    padding: 0;
    border: none;
    align-items: ${({ stacked }) => (stacked ? 'flex-start' : 'middle')};
    flex-wrap: wrap;
    gap: 6px;
    flex-direction: ${({ stacked }) => (stacked ? 'column' : 'row')};
`;
